import { defineStore } from 'pinia'

export const useMediaStore = defineStore('media', {
  state: () => ({
    documents: []
  }),

  actions: {
    setDocuments (value) {
      this.documents = value
    }
  }
})
